import { motion } from "framer-motion";

const POINTS = [
  { num: "01", text: "Equipo propio que sube y gestiona cada inmueble", testid: "about-point-team" },
  { num: "02", text: "Pisos y casas en alquiler y venta en toda España", testid: "about-point-spain" },
  { num: "03", text: "App para verlos y hablar directo por WhatsApp", testid: "about-point-app" },
];

export default function About() {
  return (
    <section id="quienes-somos" className="scroll-mt-24 bg-[#f7f4ee] py-20 dark:bg-[#0c1a29] sm:py-28" data-testid="about-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-[#0f766e] dark:text-[#14b8a6]">Quiénes somos</p>
          <h2 className="mt-3 font-serif text-3xl font-semibold text-[#12263a] dark:text-[#f7f4ee] sm:text-4xl">
            Un portal inmobiliario de confianza
          </h2>
          <p className="mt-6 font-serif text-lg italic leading-relaxed text-[#12263a]/80 dark:text-[#f7f4ee]/75 sm:text-xl">
            Nidoria es un portal inmobiliario con pisos y casas en alquiler y venta en toda España. Nuestro propio equipo
            busca, revisa y publica cada inmueble, para que solo encuentres opciones reales y a los mejores precios.
          </p>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#12263a]/60 dark:text-[#f7f4ee]/55">
            Con la app los tienes todos en el bolsillo y hablas directamente con nosotros por WhatsApp: sin registros,
            sin formularios y sin letra pequeña.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-8 sm:grid-cols-3">
          {POINTS.map((point, i) => (
            <motion.div
              key={point.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="border-t-2 border-[#0f766e] pt-5 dark:border-[#14b8a6]"
              data-testid={point.testid}
            >
              <span className="font-serif text-sm font-bold text-[#0f766e] dark:text-[#14b8a6]">{point.num}</span>
              <p className="mt-2 text-base font-semibold leading-snug text-[#12263a] dark:text-[#f7f4ee]">{point.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
